<template>
    <m-main-layout>
        <div class="page-content-main">
            <el-form :model="searchForm" ref="searchForm">
                <el-row :gutter="10">
                    <el-col :span="4">
                        <el-form-item label="UID：">
                            <el-input v-model="searchForm.uid"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="真是姓名：">
                            <el-input v-model="searchForm.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="昵称：">
                            <el-input v-model="searchForm.nickname"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="手机：">
                            <el-input v-model="searchForm.mobile"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="状态：" prop="state">
                            <el-select v-model="searchForm.state">
                                <el-option label="-全部-" value=""></el-option>
                                <el-option label="正常" value="1"></el-option>
                                <el-option label="禁用" value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="是否绑定微信：" prop="is_wechat">
                            <el-select v-model="searchForm.is_wechat">
                                <el-option label="-全部-" value=""></el-option>
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="3">
                        <el-form-item label="是否实名认证：" prop="is_realname">
                            <el-select v-model="searchForm.is_realname">
                                <el-option label="-全部-" value=""></el-option>
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item label="设置交易密码：" prop="is_trade_pass">
                            <el-select v-model="searchForm.is_trade_pass">
                                <el-option label="-全部-" value=""></el-option>
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item label="是否网红：" prop="is_uper">
                            <el-select v-model="searchForm.is_uper">
                                <el-option label="-全部-" value=""></el-option>
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item label="是否VIP：" prop="vip_state">
                            <el-select v-model="searchForm.vip_state">
                                <el-option label="-全部-" value=""></el-option>
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="注册时间：">
                            <el-date-picker
                                value-format="yyyy-MM-dd"
                                v-model="searchForm.create_time"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="最后登录时间：">
                            <el-date-picker
                                value-format="yyyy-MM-dd"
                                v-model="searchForm.last_time"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-button type="primary" @click="toSearch">查询</el-button>
                <el-button @click="clearSearch">清空</el-button>
            </el-form>
            <el-table :data="dataList" default-expand-all style="width: 100%" row-key="id"
                      :tree-props="{children: 'child'}" :indent="30" v-if="dataList.length > 0">
                <el-table-column
                    prop="id"
                    label="UID">
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="真是姓名/昵称/手机/邀请码">
                    <template slot-scope="scope">
                        姓名：{{ scope.row.name ? scope.row.name : '——' }}<br/>
                        昵称：{{ scope.row.nickname }}<br/>
                        手机号：{{ scope.row.mobile }}<br/>
                        邀请码：{{ scope.row.i_code }}<br/>
                        是否参与：
                        <el-tag :type="scope.row.is_tree_buy === 1 ? 'success' : 'danger'" disable-transitions>
                            {{ scope.row.is_tree_buy === 0 ? '否' : '是' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="头像">
                    <template slot-scope="scope">
                        <img
                            :src="scope.row.avatar.indexOf('http') >= 0 ? ($utils.isWxImg(scope.row.avatar) ? scope.row.avatar : scope.row.avatar +'!face') : $config.assetsUrl + scope.row.avatar"
                            height="40"/>
                    </template>
                </el-table-column>
                <el-table-column
                    label="零钱(元)">
                    <template slot-scope="scope">
                        <a href="#" class="under">{{ scope.row.credit.balance }}</a><br/>
                        <base-button @click.native="reCredit(scope.row.id,'balance')" type="warning" rule="/user/check" size="mini">归零</base-button><br/>
                        <base-button class="margin-top" @click.native="incCredit(scope.row.id,'balance')" type="success" rule="/user/check" size="mini">增加</base-button><br/>
                        <base-button class="margin-top" @click.native="decCredit(scope.row.id,'balance')" type="danger" rule="/user/check" size="mini">减少</base-button>
                    </template>
                </el-table-column>
                <el-table-column
                    label="优惠券(元)">
                    <template slot-scope="scope">
                        <a href="#" class="under">{{ scope.row.credit.coupon }}</a>
                    </template>
                </el-table-column>
                <el-table-column
                    label="金币(个)">
                    <template slot-scope="scope">
                        <a href="#" class="under">{{ scope.row.credit.gold }}</a><br/>
                        <base-button @click.native="reCredit(scope.row.id,'gold')" type="warning" rule="/user/check" size="mini">归零</base-button><br/>
                        <base-button class="margin-top" @click.native="incCredit(scope.row.id,'gold')" type="success" rule="/user/check" size="mini">增加</base-button><br/>
                        <base-button class="margin-top" @click.native="decCredit(scope.row.id,'gold')" type="danger" rule="/user/check" size="mini">减少</base-button>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="state"
                    label="状态" style="font-size:12px;" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.state === 1 ? 'success' : 'danger'" disable-transitions>
                            {{ scope.row.state === 0 ? '禁用' : '正常' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="create_time"
                    label="注册时间">
                    <template slot-scope="scope">
                        {{ scope.row.create_time === 0 ? '—' : $moment.unix(scope.row.create_time).format('YYYY-M-D HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column align="right" min-width="100">
                    <template slot-scope="scope">
                        <base-button @click.native="reTradePass(scope.row.id)" type="warning" rule="/user/reTradePass">
                            重置交易密码
                        </base-button>
                        <base-button @click.native="check(scope.row.id,1)" type="warning" rule="/user/check"
                                     v-if="scope.row.state === 0">启用
                        </base-button>
                        <base-button @click.native="check(scope.row.id,0)" type="danger" rule="/user/check"
                                     v-if="scope.row.state === 1">禁用
                        </base-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="text-center null-data f14 info" v-else>
                还没有数据
            </div>
            <div class="text-center padding-top-bottom-20" v-if="dataList.length > 0">
                <el-pagination
                    background
                    layout="total,prev, pager, next"
                    :page-size="pageSize"
                    :current-page.sync="searchForm.page"
                    :total="totalCount"
                    @current-change="pageChange">
                </el-pagination>
            </div>
        </div>
    </m-main-layout>
</template>

<script>
export default {
    name: "MemberList",
    data() {
        return {
            dataList: [],
            totalPage: 0,
            totalCount: 0,
            pageSize: 20,
            searchForm: {
                uid: '',
                name: '',
                state: '',
                mobile: '',
                nickname: '',
                create_time: '',
                last_time: '',
                page: 1,
                is_wechat: '',
                is_trade_pass: '',
                is_realname: '',
                is_uper: '',
                vip_state: ''
            },
        }
    },
    created() {
        let _query = this.$route.query;
        this.searchForm = {...this.searchForm, ..._query};
        this.searchForm.page = _query.page ? parseInt(_query.page) : 1;
    },
    methods: {
        toSearch() {
            this.searchForm.page = 1;
            this.$router.replace({query: this.searchForm});
            this.getList();
        },
        clearSearch() {
            this.searchForm = {
                uid: '',
                name: '',
                state: '',
                mobile: '',
                nickname: '',
                create_time: '',
                last_time: '',
                is_wechat: '',
                is_trade_pass: '',
                is_realname: '',
                is_uper: '',
                vip_state: '',
                page: 1
            };
            this.$router.replace({query: this.searchForm});
            this.getList();
        },
        getList() {
            let _this = this;
            this.dataList = [];
            this.$http.httpPost({
                url: 'User/listPage',
                datas: {...this.searchForm, pageSize: this.pageSize},
                success: (res) => {
                    console.log(res);
                    _this.dataList = res.list;
                    _this.totalPage = res.totalPage;
                    _this.totalCount = res.totalCount;
                }
            });
        },
        pageChange(page) {
            this.searchForm.page = page;
            this.$router.replace({query: this.searchForm});
            this.getList();
        },
        reTradePass(id) {
            let _this = this;

            this.$confirm('是否将密码重置为123456', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.httpPost({
                    url: 'User/reTradePass',
                    datas: {uid: id},
                    success: (res) => {
                        if (res === 'ok') {
                            _this.$message.success("重置成功");
                        }
                    }
                });
            }).catch(() => {
            });
        },
        check(id, state) {
            let _this = this;
            let _text;

            if (state === 1) {
                _text = '是否将该用户恢复正常？'
            } else if (state === 0) {
                _text = '是否禁用该用户？'
            }

            this.$confirm(_text, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.httpPost({
                    url: 'User/changeState',
                    datas: {id: id, state: state},
                    success: (res) => {
                        _this.getList();
                    }
                });
            }).catch(() => {
            });
        },
        reCredit(id,type) {
            let _this = this;

            this.$confirm('是否重置数值为0', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.httpPost({
                    url: 'User/reCredit',
                    datas: {uid: id, type: type},
                    success: (res) => {
                        _this.getList();
                    }
                });
            }).catch(() => {
            });
        },
        incCredit(id,type){
            let _this = this;
            this.$prompt('请输入数量', '增加', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /[1-9]/,
                inputErrorMessage: '数量不正确'
            }).then(({ value }) => {
                _this.$http.httpPost({
                    url: 'User/ediCredit',
                    datas: {uid: id, type: type,count:value,to:'inc'},
                    success: (res) => {
                        _this.getList();
                    }
                });
            }).catch(() => {

            });
        },
        decCredit(id,type){
            let _this = this;
            this.$prompt('请输入数量', '减少', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /[1-9]/,
                inputErrorMessage: '数量不正确'
            }).then(({ value }) => {
                _this.$http.httpPost({
                    url: 'User/ediCredit',
                    datas: {uid: id, type: type,count:value,to:'dec'},
                    success: (res) => {
                        _this.getList();
                    }
                });
            }).catch(() => {

            });
        }
    },
    mounted() {
        this.getList();
    }
}
</script>
<style scoped>
.el-select, .el-range-editor {width: 100%;}
</style>
